var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfCircleArrow = function SvgHalfCircleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#171D38",
    d: "m12.75 9.75 3-3-3-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#171D38",
    d: "M9.75 14.25H6a3.75 3.75 0 1 1 0-7.5h9.75"
  }))));
};
export default SvgHalfCircleArrow;